import { Tooltip as MuiTooltip, withStyles } from "@material-ui/core";
import { colors } from "@styles/color.styles";
import React, { PropsWithChildren } from "react";

const Tooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: colors.yellow.lightest,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[3],
    padding: 10,
    borderColor: colors.yellow.lighter,
  },
  arrow: {
    "&:before": {
      border: `1px solid ${colors.yellow.lightest}`,
    },
    color: colors.yellow.lightest,
    fontSize: 12,
  },
  tooltipPlacementBottom: {
    top: 2,
    right: 4,
  },
}))(MuiTooltip);

type Props = PropsWithChildren<{
  title: string | JSX.Element;
  open?: boolean;
}>;

export function WarningTooltip({ title, open = false, children }: Props) {
  if (!children) {
    return null;
  }

  return (
    <Tooltip title={title} arrow open={open} placement="bottom">
      {/* Cast because MUI type for children does not match React :-( */}
      {children as React.ReactElement}
    </Tooltip>
  );
}
